angular.module('homebot.directives')

  .directive('mortgageForm', ['DataService', 'HelperService', 'UtilService', 'LoanFormParser', function(DataService, helpers, utils, loanFormParser){
    return {
      controllerAs: 'ctrl',
      bindToController: {
        addMortgage: '@',
        editMortgage: '=',
        homeId: '@',
        onMortgageSaved: '&',
        onCancel: '&'
      },
      restrict: 'E',
      scope: {},
      templateUrl: '/homes/templates/add-edit-mortgage.html',
      controller: function(){
        var ctrl = this;
        ctrl.formStep = 1;

        var onSave = function(loan){
            ctrl.loading = false;

            if(ctrl.onMortgageSaved)
              ctrl.onMortgageSaved();
          };

        var onError = function(errorMsg){
            ctrl.error = errorMsg;
            ctrl.loading = false;
            utils.trackException('Add Save Mortgage', errorMsg);
          };

        ctrl.isEditMode = function(){
          return !helpers.isFalsey(ctrl.editMortgage);
        };

        ctrl.setupLoan = function(){
          ctrl.formStep = 1;
          ctrl.deletingLoan = false;

          if(ctrl.isEditMode())
            ctrl.mortgage = loanFormParser.parseForEditing(ctrl.editMortgage);
          else
            ctrl.mortgage = getNewLoanDefaults();
        };

        ctrl.saveLoan = function(){
          if(!ctrl.homeId)
            return onError('Home ID is required');

          var loan = loanFormParser.parse(ctrl.mortgage);
          ctrl.loading = true;

          DataService.saveLoan(loan, ctrl.mortgage.id)
            .then(onSave)
            .catch(onError);

          utils.track('SaveMortgage');
        };

        ctrl.addLoan = function(){
          var loan = loanFormParser.parse(ctrl.mortgage);

          DataService.addLoan(loan, ctrl.homeId)
            .then(onSave)
            .catch(onError);

          utils.track('AddMortgage');
        };

        ctrl.submitLoan = function(){
          if(ctrl.isEditMode())
            ctrl.saveLoan();
          else
            ctrl.addLoan();
        };

        ctrl.deleteLoan = function(){
          ctrl.loading = true;

          DataService.saveLoan({status:'deleted'}, ctrl.mortgage.id)
            .then(onSave)
            .catch(onError);

          utils.track('DeleteMortgage');
        };

        ctrl.nextForm = function(){
          ctrl.formStep ++;
        };

        ctrl.previousForm = function(){
          ctrl.formStep --;
        };

        function getNewLoanDefaults(){
          return { loan_type: 'FIRST CEL', term: 'FIX30YR' };
        };

      },

      link: function($scope, el, attrs, ctrl){
        $scope.$watchGroup(['ctrl.editMortgage', 'ctrl.addMortgage'], function(newValues, oldValues){
            ctrl.setupLoan();
        });
      }
    }
  }]);
